<template>
  <div class="auth">
    <NavBar />
    <h3>{{ t('sign-in-title') }}</h3>
    <p v-if="$route.query.next" class="info">{{ t('sign-in-required') }}</p>
    <component :is="section" v-for="(section, i) in sections" :key="i" />
    <form novalidate @submit.prevent="submit">
      <label>{{ t('field-email') }}<input v-model="email" type="email" name="email" autocomplete="username" /></label>
      <label>{{ t('field-password') }}<input v-model="password" type="password" name="password" autocomplete="current-password" /></label>
      <p v-if="error" class="warn">{{ error }}</p>
      <button type="submit" :disabled="busy">{{ t('button-sign-in') }}</button>
    </form>
    <p>
      <router-link :to="{ name: 'forgot-password' }">{{ t('sign-in-forgot-link') }}</router-link>
      &nbsp;
      <router-link :to="{ name: 'register', query: $route.query.next ? { next: $route.query.next } : {} }">{{ t('home-register-link') }}</router-link>
    </p>
  </div>
</template>

<script>
import NavBar from './NavBar';
import auth from '@/auth';
import extensions from '@/extensions';
import { t, errorText } from '@/texts';

export default {
  name: 'SignInPage',
  components: { NavBar },
  data() {
    return { sections: extensions.signInSections, email: '', password: '', error: null, busy: false };
  },
  methods: {
    t,
    async submit() {
      this.error = null;
      this.busy = true;
      try {
        await auth.signIn(this.email, this.password);
        this.$router.replace(this.$route.query.next || { name: 'list' });
      } catch (e) {
        this.error = errorText(e.msg || String(e));
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style src="./auth.css"></style>
